import { ColorSwatch, SelectionSetInput, SelectionSetLabel } from '@vp/swan'
import { ColorSwatchWrapperProps } from '~/client/components/common/ColorSwatchPicker/components/ColorSwatchWrapper/interface'
import { getColorSwatchColors } from '~/client/utils/getColorSwatchColors'
import { useMemo } from 'react'
import { useI18nColorName } from '~/client/hooks/useI18nColorName'

export const ColorSwatchWrapper = ({ colorSwatch, locale, isColorSwatchColorsSimilar }: ColorSwatchWrapperProps) => {
  const { designId, colorComposition = [] } = colorSwatch

  const { primaryColor, secondaryColor } = useMemo(
    () => getColorSwatchColors(colorComposition, isColorSwatchColorsSimilar),
    [colorComposition, isColorSwatchColorsSimilar],
  )

  const title = useI18nColorName(primaryColor, locale)

  return (
    <SelectionSetInput aria-label={title} key={designId} value={designId}>
      <SelectionSetLabel>
        <ColorSwatch as="span" primaryColor={primaryColor} secondaryColor={secondaryColor} title={title}>
          <span className="screen-reader-text">{title}</span>
        </ColorSwatch>
      </SelectionSetLabel>
    </SelectionSetInput>
  )
}
